import React from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

import media from 'media'

import UniversalLink from 'components/UniversalLink'
import IconAI from 'components/IconAI'

import { contentByBreakpoint } from 'helpers'

const StyledIconAI = styled(IconAI)`
  display: none;

  ${media.tablet`
    width: 20px;
    height: auto;
    display: block;
  `}

  ${media.desktop`
    width: auto;
    height: auto;
  `}
`

const getCalloutContainerAttrs = ({ shortened }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  width: [1],
  fontSize: [15, 15, 16],
  minWidth: [262, 300, 470, shortened ? 464 : 552],
  maxWidth: [262, 300, 470, shortened ? 470 : 552],
})

const CalloutContainer = styled(Flex).attrs(getCalloutContainerAttrs)``

const Container = styled.div`
  display: inline-flex;
  align-items: center;
`

export default function AICallout ({ shortened, ...others }) {
  return (
    <Container {...others}>
      <StyledIconAI />
      <CalloutContainer shortened={shortened}>
        <strong style={{ marginLeft: '10px' }}>
          {contentByBreakpoint({
            mobile: <UniversalLink to="/document-ai/">Anvil AI</UniversalLink>,
            desktop: 'Anvil AI',
            giant: shortened ? 'Anvil AI' : 'Powered by Anvil AI',
          })}
        </strong>
        :
        <span style={{ marginLeft: '4px' }}>
          {contentByBreakpoint({
            mobile: 'build Webforms faster.',
            desktop: (
              <>
                a faster way to build Workflows.
                <UniversalLink to="/document-ai/" style={{ marginLeft: '6px' }}>
                  Learn more
                </UniversalLink>
              </>
            ),
          })}
        </span>
      </CalloutContainer>
    </Container>
  )
}
